import { render, staticRenderFns } from "./ExpiryTable.vue?vue&type=template&id=47083009"
import script from "./ExpiryTable.vue?vue&type=script&lang=js"
export * from "./ExpiryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports